export interface DffSideTekst {
    sideUndertitel?: string;
    sideTekst?: string;
}
